// extracted by mini-css-extract-plugin
export default {"form__terminal":"Modal_form__terminal__1ojKS","form__terminal__footer":"Modal_form__terminal__footer__8q5l8","modal__terminal":"Modal_modal__terminal__i2u+h"};